import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

type TNoMoreItemsSize = 'normal' | 'small';

@Component({
    selector: 'fi-empty-list',
    template: `
        <div class="fi-items-list-no-more-items" [ngClass]="'size-' + noMoreItemsSize" [ngClass]="{ 'container-large-margin-top': containerLargeMarginTop }">
            @if (searchSelectionNotEmpty) {
                <div class="no-more-items-icons">
                    <span class="fas fa-sad-tear LightColor posCenter" [ngClass]="iconSize"></span>
                </div>
                <div class="DarkColor Bold no-more-items-header">{{ 'common.no_results' | fiAppText }}</div>
                @if (!hideEmptySearchDescription) {
                    <div class="LightColor italic no-more-items-text">
                        {{ 'ccmList.no_more_items_search_line_1' | fiAppText }}
                    </div>
                    <div class="LightColor italic no-more-items-text">
                        {{ 'ccmList.no_more_items_search_line_2' | fiAppText }}
                    </div>
                }
            } @else {
                <div class="no-more-items-icons">
                    <span [ngClass]="[iconClass, iconSize]" class="missing-items-icon LightColor posCenter"></span>
                </div>
                <div class="LightColor italic no-more-items-text " [ngClass]="descriptionElClass" [innerHTML]="noItemsWithoutSearchTextId | fiAppText"></div>
            }
        </div>
    `,
    styleUrls: ['./fi-empty-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-empty-list' },
    standalone: false,
})
export class FiEmptyListComponent {
    @Input() searchSelectionNotEmpty: boolean;
    @Input() hideEmptySearchDescription = false;
    @Input() noMoreItemsSize: TNoMoreItemsSize = 'normal';
    @Input() noItemsWithoutSearchTextId = 'newsFeedData.no_results';
    @Input() iconSize: 'size75' | 'size80' = 'size75';
    @Input() iconClass: string = 'fas fa-user-astronaut';
    @Input() descriptionElClass: string;
    @Input() containerLargeMarginTop: boolean = false;
}
